module.exports = __webpack_public_path__ + "img/investment_7.67cf2e81.jpg";